import React, {ReactElement, useState} from 'react';
import './tableSizeInput.css';

interface TableSizeInputProps {
    maxColumnSize: number;
    maxRowSize: number;
    createTable: (columnIndex: number, rowIndex: number) => void;
}
function TableSizeInput(props: TableSizeInputProps): ReactElement {
    const {maxColumnSize, maxRowSize, createTable} = props;

    const [mouseOver, setMouseOver] = useState({
        mouseOverColumn: -1,
        mouseOverRow: -1,
    });

    function renderTablePicker(maxColumnSize: number, maxRowSize: number): JSX.Element {
        function isBlockHighlighted(columnIndex: number, rowIndex: number): boolean {
            return columnIndex <= mouseOver.mouseOverColumn && rowIndex <= mouseOver.mouseOverRow;
        }

        return (
            <div className="u-flex u-flex-col">
                {Array(maxColumnSize)
                    .fill('')
                    .map((column, columnIndex) => {
                        return (
                            <div key={`highlighted-table-column-size-input-${columnIndex}`} className="u-flex">
                                {Array(maxRowSize)
                                    .fill('')
                                    .map((row, rowIndex) => {
                                        return (
                                            <div
                                                key={`highlighted-table-size-input-${rowIndex}`}
                                                className={`tableSizeInputBlock ${
                                                    isBlockHighlighted(columnIndex, rowIndex) ? 'highlighted' : ''
                                                }`}
                                                onClick={() => createTable(columnIndex, rowIndex)}
                                                onMouseOver={() => {
                                                    setMouseOver({
                                                        mouseOverColumn: columnIndex,
                                                        mouseOverRow: rowIndex,
                                                    });
                                                }}
                                                onFocus={() => {
                                                    setMouseOver({
                                                        mouseOverColumn: columnIndex,
                                                        mouseOverRow: rowIndex,
                                                    });
                                                }}
                                            />
                                        );
                                    })}
                            </div>
                        );
                    })}
            </div>
        );
    }

    return <div>{renderTablePicker(maxColumnSize, maxRowSize)}</div>;
}

export default TableSizeInput;
